interface Props {
  message: string;
  code?: string;
  onRetry?: () => void;
}

/** Estado de erro amigável. Para erros de banco, mostra os passos de configuração. */
export default function ErrorState({ message, code, onRetry }: Props) {
  const isDb = code?.startsWith("DB_");

  return (
    <div className="error-state">
      <div className="error-icon">{isDb ? "🗄️" : "⚠️"}</div>
      <h2>{isDb ? "Banco de dados não configurado" : "Algo deu errado"}</h2>
      <p className="error-msg">{message}</p>

      {isDb && (
        <div className="setup-box">
          <strong>Como resolver (PostgreSQL 17):</strong>
          <ol>
            <li>Crie o banco: <code>createdb sercamp_planejamento</code></li>
            <li>Ajuste a senha em <code>.env</code> → <code>DATABASE_URL</code></li>
            <li>Crie as tabelas e os dados: <code>bun run db:setup</code></li>
            <li>Reinicie: <code>bun dev</code></li>
          </ol>
        </div>
      )}

      {onRetry && (
        <button className="btn-primary" onClick={onRetry}>
          Tentar novamente
        </button>
      )}
    </div>
  );
}
